import { createStyles, Theme } from '@material-ui/core'

export const richTextViewerStyle = (theme: Theme) =>
  createStyles({
    richTextViewer: {
      inherit: 'inherit',
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    }
  })
